import { styled } from "@mui/material/styles"
import { Box } from "@mui/material"

import { ParentWrapperProps } from "./components.types"

const PageBox = styled(Box)(
  ({ theme }) => `

  flex: 1;
  min-height: 100%;
  padding: 16px 16px;
  justify-content: center;
  padding-bottom: 100px;
  padding-top: 36px;

  ${theme.breakpoints.up("sm")}{ 
    margin: 0px auto ;
  }
  `
)

export const PageWrapper = ({ children, ...props }: ParentWrapperProps) => {
  return <PageBox {...props}>{children}</PageBox>
}
